
import React, { Component } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import LostCollectionForm from './lostCollectionForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';

class LostCollection extends Component{
    state = {
        componentSteps: [
            {
                title: 'Get User',
                content: <GetInfo apiLink={getUserByPhoneApi} />,
                id: 0,
            }, {
                title: 'Create Lost Collection',
                content: <LostCollectionForm />,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <Stepper componentSteps={componentSteps} />
            </>
        )
    }
}

export default LostCollection
